module.exports = __webpack_public_path__ + "static/media/undiffer-icon.3b5d0862.svg";